module.exports = __webpack_public_path__ + "static/media/banner-slider-image1.98ef36e6.jpg";